import RecruitLocationVacancies from "../components/Recruiting/RecruitLocationVacancies.vue";
import {PERM} from "../utilites/permissions";

const recruitLocationVacancies = [
  {
    path: '/recruit_location_vacancies/:id(\\d+)?',
    name: 'RecruitLocationVacancies',
    component: RecruitLocationVacancies,
    meta: {
      requiresAuth: true,
      permissions: [
        PERM.LOCATION_VACANCY,
      ]
    },
    props: true,
  },
];

export default recruitLocationVacancies;



// WEBPACK FOOTER //
// ./src/router/recruitLocationVacancies.js